module.exports = __webpack_public_path__ + "img/hero.a4012fb2.png";